import React, { useState } from "react";
import { Card, Dropdown, Button } from "react-bootstrap";
import { FiCalendar, FiClock } from "react-icons/fi";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Link } from "react-router-dom";

const todayEmployees = [
  {
    img: "/assets/img/profiles/avatar-24-1.jpg",
    name: "Daniel Esbella",
    role: "UI/UX Designer",
    time: "09:15"
  },
  {
    img: "/assets/img/profiles/avatar-23-1.jpg",
    name: "Doglas Martini",
    role: "Project Manager",
    time: "09:36"
  },
  {
    img: "/assets/img/profiles/avatar-27-1.jpg",
    name: "Brian Villalobos",
    role: "PHP Developer",
    time: "09:15"
  }
];

const weekEmployees = [
  {
    img: "/assets/img/profiles/avatar-24-1.jpg",
    name: "Daniel Esbella",
    role: "UI/UX Designer",
    time: "08:50"
  }
];

const monthEmployees = [
  {
    img: "/assets/img/profiles/avatar-27-1.jpg",
    name: "Brian Villalobos",
    role: "PHP Developer",
    time: "09:05"
  }
];

export default function ClockInOutCard() {
  const [filter, setFilter] = useState("today");

  const getEmployees = () => {
    if (filter === "week") return weekEmployees;
    if (filter === "month") return monthEmployees;
    return todayEmployees;
  };

  return (
    <Card className="clock-card task-card h-100">

      <Card.Header className="clock-header card-header-custom">

        <h5 className="mb-0">Clock-In/Out</h5>

        <div className="header-actions">

          <Dropdown>
            <Dropdown.Toggle variant="light" size="sm">
              All Departments
              <MdKeyboardArrowDown />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>Finance</Dropdown.Item>
              <Dropdown.Item>Development</Dropdown.Item>
              <Dropdown.Item>Marketing</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Dropdown>
            <Dropdown.Toggle variant="light" className="border" size="sm">
              <FiCalendar className="me-1 mb-1" />
              {filter === "today" ? "Today" : filter === "week" ? "This Week" : "This Month"}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setFilter("today")}>
                Today
              </Dropdown.Item>

              <Dropdown.Item onClick={() => setFilter("week")}>
                This Week
              </Dropdown.Item>

              <Dropdown.Item onClick={() => setFilter("month")}>
                This Month
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

        </div>
      </Card.Header>

      <Card.Body>

        {getEmployees().map((emp, i) => (
          <Employee key={i} {...emp} />
        ))}

        {/* Summary Section */}
        <div className="summary-box">

          <div className="summary-item">
            <span className="dot green"></span>
            Clock In
            <div className="time">10:30 AM</div>
          </div>

          <div className="summary-item">
            <span className="dot red"></span>
            Clock Out
            <div className="time">09:45 AM</div>
          </div>

          <div className="summary-item">
            <span className="dot yellow"></span>
            Production
            <div className="time">09:21 Hrs</div>
          </div>

        </div>

        {/* Late Section */}
        <h6 className="late-title">Late</h6>

        <Employee
          img="/assets/img/profiles/avatar-29-1.jpg"
          name="Anthony Lewis"
          role="Marketing Head"
          time="08:35"
          late="30 Min"
        />

      <Link  className="text-decoration-none" to="/attendance-report" >
        <Button className="view-btn w-100 border border-1">
          View All Attendance
        </Button>
      </Link>

      </Card.Body>
    </Card>
  );
}

function Employee({ img, name, role, time, late }) {
  return (
    <div className="employee-row">

      <div className="employee-left">

        <img src={img} alt="" className="avatar" />

        <div>
          <h6 className="mb-0">{name}</h6>
          <small className="text-muted">{role}</small>
        </div>

        {late && (
          <span className="late-badge">
            <FiClock className="me-1" />
            {late}
          </span>
        )}

      </div>

      <span className="time-badge">
        <FiClock className="me-1" />
        {time}
      </span>
<style>
  {

    `.clock-card{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);

}

      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
.clock-header{
display:flex;
justify-content:space-between;
align-items:center;
}

.header-actions{
display:flex;
gap:10px;
}

.employee-row{
display:flex;
justify-content:space-between;
align-items:center;
border:1px dashed #e6e6e6;
border-radius:8px;
padding:9px;
margin-bottom:12px;
}

.employee-left{
display:flex;
align-items:center;
gap:10px;
}

.avatar{
width:39px;
height:39px;
border-radius:50%;
object-fit:cover;
}

.time-badge{
background:#16c47f;
color:white;
// padding:5px 10px;
border-radius:6px;
font-size:13px;
display:flex;
align-items:center;
}

.late-badge{
background:#ff3b30;
color:white;
padding:4px 8px;
border-radius:5px;
font-size:12px;
margin-left:8px;
display:flex;
align-items:center;
}

.summary-box{
display:flex;
justify-content:space-between;
border:1px solid #eee;
border-radius:8px;
padding:8px;
margin:15px 0;
}

.summary-item{
font-size:14px;
}

.summary-item .time{
font-weight:590;
margin-top:2px;
}

.dot{
width:6px;
height:6px;
display:inline-block;
border-radius:50%;
margin-right:6px;
}

.green{ background:#16c47f }
.red{ background:#ff3b30 }
.yellow{ background:#f7b500 }

.late-title{
margin:15px 0 5px;
}

.view-btn{
background:##f8f9fa;
border:none;
color:#333;
}

.view-btn:hover{
background:#eaeaea;
}
@media (max-width:576px){
.task-card{
margin-top:15px;
}
}

@media (max-width:992px){
.task-card{
margin-top:15px;
}
}

@media (max-width:1024px){
.task-card{
margin-top:15px;
}
}
    `
  }
</style>
    </div>
  );
}